class PandaApi {
    baseUrl = 'https://panda-weltmaschine.de/api/storefront/';

    notifyAboutFallbackImage(productId) {
        const path = this.baseUrl + 'fallback-image/notify';
        fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ productId })
        });
    }

    triggerMetafieldUpdate(variantId, productId, missingFields) {
        const path = this.baseUrl + 'product-cost/notify';

        // Convert empty strings to null for decimal fields
        const cleanedMissingFields = {
            total_costs: missingFields.total_costs || null,
            order_fee: missingFields.order_fee || null,
            platform_fee_rate: missingFields.platform_fee_rate || null
        };

        return fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                variant_id: String(variantId),
                product_id: String(productId),
                missing_fields: cleanedMissingFields,
                timestamp: new Date().toISOString()
            })
        });
    }
}

// Initialize global instance
if (typeof window !== 'undefined') {
    window.pandaApi = new PandaApi();
}